/* eslint-disable import/no-anonymous-default-export */
import { Address } from '../../enums/checkoutShipping';
import { stopLoading } from '../../store/application';
import shippingActions from '../../store/shippingActions';
import { loqateGAEvents } from '../analytics/google';
import { config } from '../config';
import { deepEqual } from '../js/object';
import shippingUtils from '../../utils/shipping';
import { logSentry } from '../sentry';
import { Page } from '../../enums/page';

declare const window: any;
let shippingControl: any = {};
let billingControl: any = {};
let editShippingControl: any = {};
let editBillingControl : any  = {};
let dispatch;

const showLoqateAutoComplete = ({loqateEnabled, value, shouldBlock, loqateControl}) => {
    if (loqateEnabled && value.length >= 3 && !shouldBlock) {
        loqateControl.enable();
        loqateControl.autocomplete.show();
    } else {
        loqateControl.hide();
        loqateControl.disable();
    }
}

const deliveryAddressLine1OnChange = ({ value, state, setAddressFormCall, type }) => {
    const {
        applicationState : {currentPage}, shippingState: { loqate: { loqateEnabled, blockShippingLoqateAutocomplete } }
    } = state;
    showLoqateAutoComplete({loqateEnabled, value, shouldBlock : blockShippingLoqateAutocomplete, loqateControl: shippingControl});
    if (config('regionCode') === 'US' && currentPage !== Page.MYACCOUNT) {
        shippingUtils.showHidePOBoxWarning({value, addressLine:'addressLine1', type, setAddressFormCall});
    }
}

const billingAddressLine1OnChange = ({ value, state}) => {
    const {
        shippingState: { loqate: { loqateEnabled, blockBillingLoqateAutocomplete } }
    } = state;
    showLoqateAutoComplete({loqateEnabled, value, shouldBlock : blockBillingLoqateAutocomplete, loqateControl: billingControl});
}
const editDeliveryAddressLine1OnChange = ({ value, state, type, setAddressFormCall}) => {
    const {
        shippingState: { loqate: { loqateEnabled, blockShippingLoqateAutocomplete } }
    } = state;
    showLoqateAutoComplete({loqateEnabled, value, shouldBlock : blockShippingLoqateAutocomplete, loqateControl: editShippingControl});
    if (config('regionCode') === 'US') {
        shippingUtils.showHidePOBoxWarning({value, addressLine:'addressLine1', type, setAddressFormCall});
    }
}

const editBillingAddressLine1OnChange = ({ value, state }) => {

    const {
        shippingState: { loqate: { loqateEnabled, blockBillingLoqateAutocomplete } }
    } = state;
    showLoqateAutoComplete({loqateEnabled, value, shouldBlock : blockBillingLoqateAutocomplete, loqateControl: editBillingControl});
}

const returnCulture = () => {
    const currentLocale = config('locale');
    const multiLanguageLocale = ['BE', 'CH'];
    if (currentLocale) {
        const splittedResult = currentLocale.split('-');
        if (splittedResult[1] && multiLanguageLocale.indexOf(splittedResult[1]) !== -1) {
            return splittedResult[0];
        }
    }
    return false;
}

const checkIfLoqateBlocked = ({ dispatch, locale, type }) => {
    const blockLoqateLocaleList = ['CZ', 'HU', 'JP', 'SK'];
    let updatedLocale = '';
    let blockLoqateAutocomplete = false;
    if (locale) {
        updatedLocale = locale.split('-');
        if (updatedLocale.length > 1) {
            updatedLocale = updatedLocale[1];
        } else {
            updatedLocale = updatedLocale[0];
        }
        if (updatedLocale && blockLoqateLocaleList.indexOf(updatedLocale) !== -1) {
            blockLoqateAutocomplete = true;
        }
        if (type === Address.DELIVERY) {
            dispatch(shippingActions.setBlockShippingLoqateAutocomplete(blockLoqateAutocomplete));
        } else if (type === Address.BILLING) {
            dispatch(shippingActions.setBlockBillingLoqateAutocomplete(blockLoqateAutocomplete));
        }
    }
}

const checkIfAddressModified = ({ suggestedAddress, submittedAddress }) => {
    let isModified = false;
    let addressProps = {
        'Line1' : 'streetName',
        'Line2' : 'additionalStreetInfo',
        'PostalCode' : 'postalCode',
        'City' : 'city',
        'Province' : 'state',
        'CountryIso2' : 'country'
    }
    for (const prop in addressProps) {
        if (suggestedAddress[prop] !== submittedAddress[addressProps[prop]]) {
            isModified = true;
            break;
        }
    }
    return isModified;
}

const removeAddressErrorAfterLoqateAutoFill = ({ type, setAddressFormCall }) => { 
    const highlightErrorFieldObj = {'highlightErrorField': false, 'showMsg': false};
    
    setAddressFormCall({type, modifyStateCallback :(prevState) => {
        return {
            postalCode : {...prevState[type].postalCode, ...highlightErrorFieldObj},
            county : {...prevState[type].county, ...highlightErrorFieldObj},
            city : {...prevState[type].city, ...highlightErrorFieldObj},
            country : {...prevState[type].country, ...highlightErrorFieldObj}
        }
    }});
}

const initPCAAddress = ({ dispatch, loqateFields, countryCode }) => {
    let culture;
    const loqateFieldsArray: [{
        element: string,
        field: string,
        mode?: string
    }?] = [];

    //loqate API integration
    if (loqateFields) {
        loqateFields.forEach(item => {
            loqateFieldsArray.push({
                element: item.element,
                field: item.field,
                ...(item.mode === 'POPULATE') && { mode: window.pca && window.pca.fieldMode.POPULATE }
            });
        });
    }

    if (countryCode === 'GB') {
        loqateFields.splice(3, 1);
    }
    culture = returnCulture();
    return new window.pca.Address(loqateFieldsArray, { key: config('LOQATE_API_KEY'), suppressAutocomplete: false, search: { countries: countryCode }, preselect: false, GeoLocationEnabled: true, ...(culture && culture) });
}
const setCountry = (countryCode, control) => {
    countryCode && control.setCountry(countryCode);
}
const checkIfStatePresent = (address, countyEle) => {
    if (address.Province && !countyEle) {
        address.Province = '';
    }
    return address;
}
const setCustomProvince = (address, countryCode) => {
    if (address?.Province) {
        if (countryCode === 'GB') {
            address.Province = '';
        }
        else if (countryCode === 'IT') {
            address.Province = address['ProvinceCode'];
        }
        else if (countryCode === 'IE' && address.Province.indexOf('Co.') === -1) {
            if (address.Province.indexOf('County ') !== -1) {
                address.Province = address.Province.replace('County ', '');
            }
            address.Province = `Co.${address.Province}`;
        }
    }
    return address;
}
const nzProvinceSet = (address) => {
    //check and set NZ province for loqate ABC-17185
    const tempAdd = address;
    if (tempAdd.Line2 === tempAdd.District) {
        tempAdd.Line2 = '';
    }
    tempAdd.Province = tempAdd.District;
    return tempAdd;
}

const loqatePrepopulate = ({ address, countryCode, countyEle }) => {
   // const newAddress = {};
    address = checkIfStatePresent(address, countyEle);
    if (countyEle) {
        address = setCustomProvince(address, countryCode);
    }
    //NZ locale condition
    if (countryCode === 'NZ') {
        address = nzProvinceSet(address);
    }
}
const getElement = (id): any => {
    return document.querySelector(`#${id}`);
}

const hideLoqateSuggestion = (ele, control) => {
    // If autocomplete triggers to display while the main input is not focused, hide the autocomplete
    const element = getElement(ele);
    if (document.activeElement !== element) {
        control.hide();
        control.disable();
    }
}
const resizeAutoComplete = (control, ele) => {
    const targetInputField = getElement(ele);
    if (targetInputField?.clientWidth && control.setWidth) control.setWidth(`${targetInputField.clientWidth}px`);
}
const loqateSuggestionResults = (results, id, control) => {
    // Array.prototype.isNull = function() {
    //     return this.join().replace(/,/g, '').length === 0;
    // };
    let res = results.filter(function (val) {
        return val.Type.match('Address');
    });
    results.length = 0;
    for (var i = 0; i < Math.min(res.length, Address.MAXIMUM_RESULTS_TO_SHOW); i++) {
        results.push(res[i]);
    }
    if (results.length === 0) {
        control.hide();
        control.disable();
    } else {
        resizeAutoComplete(control, id);
    }
}
const loqateCaptureException = (err, customError = null) => {
    console.log('LOQATE_API_ENDPOINT_ERROR', err);
    logSentry({
        'page': 'checkoutShipping',
        'feature': 'loqate',
        'operation': 'loqate',
        'errorType': 'ajaxError',
        'err': JSON.stringify(err),
        'func': 'loqateCaptureException',
        'api': `${window.Config.LOQATE_API_ENDPOINT}`,
        'errMsg': `Loqate Error - Checkout Shipping - ${customError ? customError : 'Could not populate / verify addresses' }`
    })
}
const initLoqate = ({ dispatch: dispatchActions, addressForm, setAddressFormCall, currentPage }) => {
    dispatch = dispatchActions;
    let deliveryFormHandle;
    let editDeliveryFormHandle;
    let billingFormHandle;
    let editBillingFormHandle;
    try {
        if (shippingControl.destroy) shippingControl.destroy();
        if (billingControl.destroy) billingControl.destroy();
        if (editShippingControl.destroy) editShippingControl.destroy();
        if (editBillingControl.destroy) editBillingControl.destroy();

        let shippingLoqateFields = [{ element: 'delivery-address-addressLine1', field: 'Line1' },
        { element: 'delivery-address-addressLine2', field: 'Line2', mode: 'POPULATE' },
        { element: 'delivery-address-city', field: 'City', mode: 'POPULATE' },
        { element: 'delivery-address-county', field: 'Province', mode: 'POPULATE' },
        { element: 'delivery-address-postalCode', field: 'PostalCode', mode: 'POPULATE' }
        ];
        let shippingCountryCode = addressForm?.shippingAddress?.country?.value ?? config('regionCode');
        shippingControl = initPCAAddress({ dispatch, loqateFields: shippingLoqateFields, countryCode: shippingCountryCode });

        if(shippingControl) {
            deliveryFormHandle = (event) => {
                if ((event.target as HTMLInputElement).value.length >= 3) {
                    shippingControl.autocomplete.focus(event.target as HTMLInputElement);
                    shippingControl.search((event.target as HTMLInputElement).value);
                }
            }

            document.getElementById('delivery-address-addressLine1')?.addEventListener('input', deliveryFormHandle);
        }

        shippingControl.listen('load', () => {
            setCountry(shippingCountryCode, shippingControl);
        });

        shippingControl.listen('display', () => {
            hideLoqateSuggestion('delivery-address-addressLine1', shippingControl);
        });

        shippingControl.listen('results', (results) => {
            loqateSuggestionResults(results, 'delivery-address-addressLine1', shippingControl);
        });

        shippingControl.listen('prepopulate', (address) => {
            const countryCode = getElement('delivery-address-country')?.value;
            const countyEle = getElement('delivery-address-county');
            loqatePrepopulate({ address, countryCode, countyEle });
        });

        shippingControl.listen('populate', (address) => {
            dispatch(shippingActions.setIsLoqateSuggestedAddress(true));
            dispatch(shippingActions.setSuggestedShippingAddress(address));
            dispatch(shippingActions.setShippingAddressType(Address.LOQATE_VALIDATED));
            loqateGAEvents(currentPage === Page.MYACCOUNT ? 'cam-shipping' :'chk-shipping', 'dropdown');
            if (config('regionCode') === 'US' && currentPage !== Page.MYACCOUNT ) {
                shippingUtils.showHidePOBoxWarning({value : address?.Line1, addressLine:'addressLine1', type: Address.SHIPPING_ADDRESS, setAddressFormCall});
                if(address?.Line2) {
                    shippingUtils.showHidePOBoxWarning({value : address?.Line2, addressLine:'addressLine2', type: Address.SHIPPING_ADDRESS, setAddressFormCall});
                } else {
                    shippingUtils.showHidePOBoxWarning({value : '', addressLine:'addressLine2', type: Address.SHIPPING_ADDRESS, setAddressFormCall});
                }
            }
            removeAddressErrorAfterLoqateAutoFill({type : Address.SHIPPING_ADDRESS, setAddressFormCall});
        });

        shippingControl.listen('error', (err) => {
            loqateCaptureException(err);
        });


        let billingLoqateFields = [{ element: 'billing-address-addressLine1', field: 'Line1' },
        { element: 'billing-address-addressLine2', field: 'Line2', mode: 'POPULATE' },
        { element: 'billing-address-city', field: 'City', mode: 'POPULATE' },
        { element: 'billing-address-county', field: 'Province', mode: 'POPULATE' },
        { element: 'billing-address-postalCode', field: 'PostalCode', mode: 'POPULATE' }
        ];
        let billingCountryCode = config('regionCode');
        billingControl = initPCAAddress({ dispatch, loqateFields: billingLoqateFields, countryCode: billingCountryCode });

        if(billingControl) {
            billingFormHandle = (event) => {
                if ((event.target as HTMLInputElement).value.length >= 3) {
                    billingControl.autocomplete.focus(event.target as HTMLInputElement);
                    billingControl.search((event.target as HTMLInputElement).value);
                }
            }

            document.getElementById('billing-address-addressLine1')?.addEventListener('input', billingFormHandle);
        }

        billingControl.listen('load', () => {
            setCountry(billingCountryCode, billingControl);
        });

        billingControl.listen('display', () => {
            hideLoqateSuggestion('billing-address-addressLine1', billingControl);
        });

        billingControl.listen('results', (results) => {
            loqateSuggestionResults(results, 'billing-address-addressLine1', billingControl);
        });

        billingControl.listen('prepopulate', (addressParam) => {
            const countryCode = getElement('billing-address-country')?.value;
            const countyEle = getElement('billing-address-county');
            let address = { ...addressParam };
            loqatePrepopulate({ address, countryCode, countyEle });
        });

        billingControl.listen('populate', (address) => {
            dispatch(shippingActions.setIsLoqateSuggestedAddress(true));
            dispatch(shippingActions.setSuggestedBillingAddress(address));
            dispatch(shippingActions.setBillingAddressType(Address.LOQATE_VALIDATED));
            loqateGAEvents(currentPage === Page.MYACCOUNT ? 'cam-billing' :'chk-billing', 'dropdown');
            removeAddressErrorAfterLoqateAutoFill({type : Address.BILLING_ADDRESS, setAddressFormCall});
        });

        billingControl.listen('error', (err) => {
            loqateCaptureException(err);
        });

        let editShippingControlFields = [{element: 'edit-delivery-address-addressLine1', field:'Line1'},
            {element: 'edit-delivery-address-addressLine2', field:'Line2', mode: 'POPULATE'},
            {element: 'edit-delivery-address-city', field:'City', mode: 'POPULATE'},
            {element: 'edit-delivery-address-county', field:'Province', mode: 'POPULATE'},
            {element: 'edit-delivery-address-postalCode', field:'PostalCode', mode: 'POPULATE'}
        ];

        let editShippingCountryCode = addressForm?.shippingAddress?.country?.value ?? config('regionCode');

        editShippingControl = initPCAAddress({ dispatch, loqateFields: editShippingControlFields, countryCode: editShippingCountryCode });
        
        if(editShippingControl) {
            editDeliveryFormHandle = (event) => {
                if ((event.target as HTMLInputElement).value.length >= 3) {
                    editShippingControl.autocomplete.focus(event.target as HTMLInputElement);
                    editShippingControl.search((event.target as HTMLInputElement).value);
                }
            }

            document.getElementById('edit-delivery-address-addressLine1')?.addEventListener('input', editDeliveryFormHandle);
        }
        
        editShippingControl.listen('load', () => {
            setCountry(editShippingCountryCode, editShippingControl);
        });

        editShippingControl.listen('display', () => {
            hideLoqateSuggestion('edit-delivery-address-addressLine1', editShippingControl);
        });

        editShippingControl.listen('results', (results) => {
            loqateSuggestionResults(results, 'edit-delivery-address-addressLine1', editShippingControl);
        });

        editShippingControl.listen('prepopulate', (address) => {
            const countryCode = getElement('edit-delivery-address-country')?.value;
            const countyEle = getElement('edit-delivery-address-county');
            loqatePrepopulate({ address, countryCode, countyEle });
        });

        editShippingControl.listen('populate', (address) => {
            dispatch(shippingActions.setIsLoqateSuggestedAddress(true));
            dispatch(shippingActions.setSuggestedShippingAddress(address));
            dispatch(shippingActions.setShippingAddressType(Address.LOQATE_VALIDATED));
            loqateGAEvents(currentPage === Page.MYACCOUNT ? 'cam-shipping' :'chk-shipping', 'dropdown');
            if (config('regionCode') === 'US') {
                shippingUtils.showHidePOBoxWarning({value : address?.Line1, addressLine:'addressLine1', type: Address.SHIPPING_ADDRESS, setAddressFormCall});
                if(address?.Line2) {
                    shippingUtils.showHidePOBoxWarning({value : address?.Line2, addressLine:'addressLine2', type: Address.SHIPPING_ADDRESS, setAddressFormCall});
                } else {
                    shippingUtils.showHidePOBoxWarning({value : '', addressLine:'addressLine2', type: Address.SHIPPING_ADDRESS, setAddressFormCall});
                }
            }
            removeAddressErrorAfterLoqateAutoFill({type : Address.SHIPPING_ADDRESS, setAddressFormCall});
        });

        editShippingControl.listen('error', (err) => {
            loqateCaptureException(err);
        });

        let editBillingControlFields = [{element: 'edit-billing-address-addressLine1', field:'Line1'},
            {element: 'edit-billing-address-addressLine2', field:'Line2', mode: 'POPULATE'},
            {element: 'edit-billing-address-city', field:'City', mode: 'POPULATE'},
            {element: 'edit-billing-address-county', field:'Province', mode: 'POPULATE'},
            {element: 'edit-billing-address-postalCode', field:'PostalCode', mode: 'POPULATE'}
        ];

        let editBillingCountryCode = config('regionCode');
        editBillingControl = initPCAAddress({ dispatch, loqateFields: editBillingControlFields, countryCode: editBillingCountryCode });

        if(editBillingControl) {
            editBillingFormHandle = (event) => {
                if ((event.target as HTMLInputElement).value.length >= 3) {
                    editBillingControl.autocomplete.focus(event.target as HTMLInputElement);
                    editBillingControl.search((event.target as HTMLInputElement).value);
                }
            }

            document.getElementById('edit-billing-address-addressLine1')?.addEventListener('input', editBillingFormHandle);
        }

        editBillingControl.listen('load', () => {
            setCountry(editBillingCountryCode, editBillingControl);
        });

        editBillingControl.listen('display', () => {
            hideLoqateSuggestion('edit-billing-address-addressLine1', editBillingControl);
        });

        editBillingControl.listen('results', (results) => {
            loqateSuggestionResults(results, 'edit-billing-address-addressLine1', editBillingControl);
        });

        editBillingControl.listen('prepopulate', (address) => {
            const countryCode = getElement('edit-billing-address-country')?.value;
            const countyEle = getElement('edit-billing-address-county');
            loqatePrepopulate({ address, countryCode, countyEle });
        });

        editBillingControl.listen('populate', (address) => {
            dispatch(shippingActions.setIsLoqateSuggestedAddress(true));
            dispatch(shippingActions.setSuggestedBillingAddress(address));
            dispatch(shippingActions.setBillingAddressType(Address.LOQATE_VALIDATED));
            loqateGAEvents(currentPage === Page.MYACCOUNT ? 'cam-billing' :'chk-billing', 'dropdown');
            // setSuggestedBillingAddress(address);
            removeAddressErrorAfterLoqateAutoFill({type : Address.BILLING_ADDRESS, setAddressFormCall});
        });
        editBillingControl.listen('error', (err) => {
            loqateCaptureException(err);
        });
    } catch (err) {
        console.log('Error in initializing loqate', err);
        logSentry({
            'page': 'checkoutShipping',
            'feature': 'initLoqate',
            'operation': 'initLoqate',
            'errorType': 'ajaxError',
            'err': JSON.stringify(err),
            'func': 'initLoqate',
            'api': null,
            'errMsg': 'Error: while initializing loqate'
        })
    }

    return [deliveryFormHandle, editDeliveryFormHandle, billingFormHandle, editBillingFormHandle];
}

const initializeLoqateFlow = ({ dispatch, addressForm, setAddressFormCall, selectedCountry, currentPage }) => {
    checkIfLoqateBlocked({ dispatch, locale: selectedCountry, type: Address.DELIVERY });
    checkIfLoqateBlocked({ dispatch, locale: config('regionCode'), type: Address.BILLING });
    let formEventHandlers = initLoqate({ dispatch, addressForm, setAddressFormCall, currentPage });
    return formEventHandlers;
}

const formatRecommendAddress = (userAddressObject, recommendedAddress) => {
    const formatedRecommendAddress = JSON.parse(JSON.stringify(userAddressObject));
    if (userAddressObject.country === 'NZ') {
        if (recommendedAddress.DeliveryAddress2 === recommendedAddress.District) {
            recommendedAddress.DeliveryAddress2 = '';
        }
        formatedRecommendAddress['state'] = userAddressObject.state ? (recommendedAddress.District ? recommendedAddress.District.replace(/\s+/g, '') : userAddressObject.state) : '';
    } else {
        formatedRecommendAddress['state'] = userAddressObject.state ? (recommendedAddress.AdministrativeArea ? recommendedAddress.AdministrativeArea.replace(/\s+/g, '') : userAddressObject.state) : '';
    }
    formatedRecommendAddress['streetName'] = recommendedAddress.DeliveryAddress1 || '';
    formatedRecommendAddress['additionalStreetInfo'] = recommendedAddress.DeliveryAddress2 || '';
    formatedRecommendAddress['postalCode'] = recommendedAddress.PostalCode || '';
    formatedRecommendAddress['city'] = recommendedAddress.Locality || '';

    return formatedRecommendAddress;
}

const setManualAddressFields = async ({dispatch, addressType, options, shippingBillingSync, isLoggedIn, addressValidationType, AQI = ''}) => {
    let updateAddress = false;
    let { customerId, addressId } = options;
    if(isLoggedIn === 'true' && addressId) {
        let customField : any = {
            ...(addressValidationType === Address.LOQATE_VALIDATED && {AQI}),
            addressValidationType: addressValidationType
        };
        updateAddress = await dispatch(shippingActions.updateLoqateAddressField(customerId, addressId, customField));
    }
    else {
        updateAddress = true;
    }
    if (updateAddress) {
        if (addressType === Address.SHIPPING_ADDRESS) {
            dispatch(shippingActions.setShippingAddressType(addressValidationType));
            if (shippingBillingSync) {
                dispatch(shippingActions.setBillingAddressType(addressValidationType));
            }
        } else if (addressType === Address.BILLING_ADDRESS) {
            dispatch(shippingActions.setBillingAddressType(addressValidationType))
        }
    }
}

const hideLoqateValidationModal = async ({dispatch, addressType, address, options, shippingBillingSync,  isLoggedIn, addressValidationType, AQI = ''}) => {
    if(!address.AQI || !address.DeliveryAddress1 || !address.Locality) {
        await setManualAddressFields({dispatch, addressType, options, shippingBillingSync,  isLoggedIn, addressValidationType, AQI});
        return true;
    }
    return false;
}
const isRecommendedAddressValid = (res) => {
    return res && Array.isArray(res) && res[0]?.Matches?.[0] && Object.keys(res[0].Matches[0]).length !== 0;
}

const verifyAddressWithLoqate = async ({ dispatch, shippingAddress, billingAddress, isLoggedIn, customerId, currentPage }) => {
    try {
        let showShippingLoqatePopup = false;
        let showBillingLoqatePopup = false;

        if (shippingAddress.status === Address.UNKNOWN) {
            let recommendedAddress = await dispatch(shippingActions.getRecommendAddress(shippingAddress.submittedAddress));

            if (isRecommendedAddressValid(recommendedAddress)) {
                let recAddressObj = recommendedAddress[0]['Matches'][0];
                let formattedRecAddressObj = formatRecommendAddress(shippingAddress.submittedAddress, recAddressObj);
                let isEqual = deepEqual(JSON.parse(JSON.stringify(shippingAddress.submittedAddress)), JSON.parse(JSON.stringify(formattedRecAddressObj)));
                dispatch(shippingActions.setFormattedShippingAddress(formattedRecAddressObj));
                dispatch(shippingActions.setShippingAQI(recAddressObj.AQI));
                if (isEqual) {
                    loqateGAEvents(currentPage === Page.MYACCOUNT ? 'cam-shipping' :'chk-shipping', 'recommended');
                    if (shippingAddress.shippingBillingAgreement) {
                        billingAddress.status = Address.LOQATE_VALIDATED;
                        loqateGAEvents(currentPage === Page.MYACCOUNT ? 'cam-billing' :'chk-billing', 'recommended');
                    }
                    await setManualAddressFields({dispatch, addressType : Address.SHIPPING_ADDRESS, options: { customerId, addressId : shippingAddress?.submittedAddress?.id }, shippingBillingSync : shippingAddress.shippingBillingAgreement, isLoggedIn, addressValidationType : Address.LOQATE_VALIDATED, AQI: recAddressObj.AQI});
                } else {
                    let hideLoqateModal = await hideLoqateValidationModal({dispatch, addressType : Address.SHIPPING_ADDRESS, address : recAddressObj, options: {customerId, addressId : shippingAddress.submittedAddress?.id }, shippingBillingSync: shippingAddress.shippingBillingAgreement,  isLoggedIn, addressValidationType : Address.USER_VALIDATED, AQI: ''});
                    if(!hideLoqateModal) {
                        dispatch(shippingActions.setShowShippingPopup(true));
                        showShippingLoqatePopup = true;
                    } else {
                        if (shippingAddress.shippingBillingAgreement) {
                            billingAddress.status = Address.USER_VALIDATED;
                        }
                    }
                }
            }
            else {
                loqateCaptureException(recommendedAddress);
                await setManualAddressFields({dispatch, addressType : Address.SHIPPING_ADDRESS, options: { customerId, addressId : shippingAddress.submittedAddress.id }, shippingBillingSync : shippingAddress.shippingBillingAgreement, isLoggedIn, addressValidationType : Address.USER_VALIDATED, AQI: ''});
            }
        }
        if (billingAddress.status === Address.UNKNOWN) {
            let recommendedAddress = await dispatch(shippingActions.getRecommendAddress(billingAddress.submittedAddress));

            if (isRecommendedAddressValid(recommendedAddress)) {
                let recAddressObj = recommendedAddress[0]['Matches'][0];
                let formattedRecAddressObj = formatRecommendAddress(billingAddress.submittedAddress, recAddressObj);
                dispatch(shippingActions.setFormattedBillingAddress(formattedRecAddressObj));
                dispatch(shippingActions.setBillingAQI(recAddressObj.AQI));
                let isEqual = deepEqual(JSON.parse(JSON.stringify(billingAddress.submittedAddress)), JSON.parse(JSON.stringify(formattedRecAddressObj)));
                if (isEqual) {
                    loqateGAEvents(currentPage === Page.MYACCOUNT ? 'cam-billing' :'chk-billing', 'recommended');
                    await setManualAddressFields({dispatch, addressType : Address.BILLING_ADDRESS, options: {customerId, addressId : billingAddress.submittedAddress.id }, shippingBillingSync : false, isLoggedIn, addressValidationType : Address.LOQATE_VALIDATED, AQI: recAddressObj.AQI});
                } else {
                    let hideLoqateModal = await hideLoqateValidationModal({dispatch, addressType : Address.BILLING_ADDRESS, address : recAddressObj, options: {customerId, addressId : billingAddress.submittedAddress.id}, shippingBillingSync:false,  isLoggedIn, addressValidationType : Address.USER_VALIDATED, AQI: ''});
                    if(!hideLoqateModal) {
                        dispatch(shippingActions.setShowBillingPopup(true));
                        showBillingLoqatePopup = true;
                    }
                }
            }
            else {
                loqateCaptureException(recommendedAddress);
                await setManualAddressFields({dispatch, addressType : Address.BILLING_ADDRESS, options: {customerId, addressId : billingAddress.submittedAddress.id }, shippingBillingSync : false, isLoggedIn, addressValidationType : Address.USER_VALIDATED, AQI: ''});
            }
        }
        dispatch(stopLoading());
        if (showShippingLoqatePopup || showBillingLoqatePopup) {
            return true;
        }
        return false;
    } catch (err) {
        dispatch(stopLoading());
        logSentry({
            'page': 'checkoutShipping',
            'feature': 'verifyAddressWithLoqate',
            'operation': 'verifyAddressWithLoqate',
            'errorType': 'ajaxError',
            'err': JSON.stringify(err),
            'func': 'verifyAddressWithLoqate',
            'api': null,
            'errMsg': 'Error: while verifing address with loqate'
        })
    }
}
export {
    initPCAAddress,
    initLoqate,
    initializeLoqateFlow,
    checkIfLoqateBlocked,
    checkIfAddressModified,
    deliveryAddressLine1OnChange,
    billingAddressLine1OnChange,
    editDeliveryAddressLine1OnChange,
    editBillingAddressLine1OnChange,
    verifyAddressWithLoqate
}
